import styled from "styled-components/macro";

import {
  AddPaymentMethodSettingsSummaryBar,
  usePaymentMethodState,
} from "Payments/AddPaymentMethod";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { AnimatePresence, motion } from "framer-motion";

import FnrButton, { ButtonText } from "UI/FnrButton3";

export default function SubmitButtons({
  showAdditionalSettings,
  setShowAdditionalSettings,
  setInputErrors,
  setShouldClearDisplayMessages,
  goBack,
}) {
  const { submitting, deleting, savePaymentMethod } = usePaymentMethodState();
  const {
    state: {
      fund: { fundColorSafe },
      currentScreen,
    },
  } = usePaymentPage();

  const handleSave = () => {
    if (submitting || deleting) return;
    savePaymentMethod();
  };

  const shouldShowAdditionalSettings = () => {
    if (!submitting) setShowAdditionalSettings(true);
  };

  return (
    <Wrapper>
      <AnimatePresence>
        {!showAdditionalSettings && (
          <SummaryBarHolder
            key="summary"
            onClick={shouldShowAdditionalSettings}
            exit={{
              opacity: 0,
            }}
          >
            <AddPaymentMethodSettingsSummaryBar currentScreen={currentScreen} />
          </SummaryBarHolder>
        )}
      </AnimatePresence>
      <Spacer />
      <SaveButtonHolder>
        <FnrButton
          data-cy="newPaymentMethodNextButton"
          color={fundColorSafe}
          onClick={handleSave}
          loading={submitting}
          disabled={submitting || deleting}
        >
          <ButtonText>Next</ButtonText>
        </FnrButton>
      </SaveButtonHolder>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SummaryBarHolder = styled(motion.div)`
  flex-shrink: 0;
`;
const Spacer = styled.div`
  flex-grow: 1;
`;

const SaveButtonHolder = styled.div`
  flex-shrink: 0;
  margin-left: 8px;
`;

const BackButtonHolder = styled.div`
  flex-shrink: 0;
  margin-right: 8px;
`;
